import React, { useState } from 'react'
import { Card, CardBody, CardHeader, Col, Pagination, PaginationItem, PaginationLink, Row, Spinner } from 'reactstrap'
import useListCreditTransaction from './hooks/useListCreditTransaction'

const Transaction = () => {
    // pagination
    const[currentPage,setCurrentPage]=useState(1);
    const pageSize = 10;
    // search
    const[searchTerm,setSearchTerm]=useState('');
    // hook
    const {isPending,isError,isSuccess,error,data} = useListCreditTransaction(currentPage,pageSize,searchTerm);
    
    const history = data?.results || [];
    const  totalCount = data?.count || 0;
    const totalPages = Math.ceil(totalCount/pageSize);
    
  return (
    <Row>
        <Col>
            <Card className='p-3'>
                <div style={{maxHeight:"500px",overflowY:"auto"}}>
                    {
                    isPending && (
                        <div className='d-flex justify-content-between align-items-center py-3'>
                            <Spinner/>
                        </div>
                        )
                    }

                    {
                        isError && (
                            <div className='d-flex justify-content-between align-items-center py-3'>
                                <h6>Error fetching data: {error.message}</h6>
                            </div>
                        
                        )
                    }
                    
                    {
                        !isPending && history.length === 0 && (
                            <div  className='d-flex justify-content-between align-items-center py-3'>
                                <div className="d-flex flex-column align-items-center text-muted">
                                <i className="bi bi-exclamation-circle fs-1 mb-2"></i>
                                <h5 className="mb-1">No Data Found</h5>
                                </div>
                            </div>
                        )
                    }
                    
                    {
                        history.map((his,index)=>(
                            <div key={index} className='d-flex justify-content-between align-items-center border-bottom border-capacity-25 py-3'>
                                <div>
                                    <h6 className='mb-1'>{his.product_type?.startsWith("DA") ? his.product_type.replace("DA","Desktop Appraisal") : his.product_type ? his.product_type : 'Bulk Order'}</h6>
                                    <p className='mb-0 text-muted'>{new Date(his.created_date).toLocaleDateString('en-US')}</p>
                                </div>
                                <div className='fw-bold me-4'>
                                    ${Number(his.credit_used).toLocaleString('en-us')}
                                </div>
                            </div>
                        ))
                    }
                </div>
            </Card>
            
            <div style={{display:"flex", flexDirection:"row", alignItems:"end", justifyContent:"end"}}>
              <Pagination size='sm' className='justify-content-center'>
                {/* first page */}
                <PaginationItem disabled={currentPage === 1}>
                  <PaginationLink
                    first
                    onClick={()=> setCurrentPage(1)}
                    style={{
                      backgroundColor: '#f8f9fa',
                      color: '#007bff',
                      border: '1px solid #dee2e6',
                      padding: '5px 10px',
                      cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                    }}
                  />
                </PaginationItem>

                {/* previous page */}
                <PaginationItem disabled={currentPage === 1}>
                    <PaginationLink
                      previous
                      onClick={()=>setCurrentPage(prev => prev - 1)}
                      style={{
                        backgroundColor: '#f8f9fa',
                        color: '#007bff',
                        border: '1px solid #dee2e6',
                        padding: '5px 10px',
                        cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                    }}
                    />
                </PaginationItem>

                {/* page numbers */}
                {[...Array(totalPages)].map((_,index)=>{
                  const isActive = currentPage === index + 1;
                  return(
                    <PaginationItem key={index} active={isActive}>
                      <PaginationLink
                        onClick={()=> setCurrentPage(index + 1)}
                        style={{
                          backgroundColor: isActive ? '#007bff' : '#fff',
                          color: isActive ? '#fff' : '#007bff',
                          border: '1px solid #dee2e6',
                          padding: '5px 12px',
                          margin: '0 2px',
                          cursor: 'pointer',
                          borderRadius: '4px',
                          fontWeight: isActive ? 'bold' : 'normal',
                        }}
                      >
                        {index + 1}
                      </PaginationLink>
                    </PaginationItem>
                  )
                })}

                {/* next page */}
                <PaginationItem disabled={currentPage === totalPages}>
                  <PaginationLink
                    next
                    onClick={()=> setCurrentPage(prev => prev + 1)}
                    style={{
                      backgroundColor: '#f8f9fa',
                      color: '#007bff',
                      border: '1px solid #dee2e6',
                      padding: '5px 10px',
                      cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                    }}
                  />
                </PaginationItem>

                {/* last page */}
                <PaginationItem disabled={currentPage === totalPages}>
                    <PaginationLink
                      last
                      onClick={()=> setCurrentPage(totalPages)}
                      style={{
                        backgroundColor: '#f8f9fa',
                        color: '#007bff',
                        border: '1px solid #dee2e6',
                        padding: '5px 10px',
                        cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                      }}
                    />
                </PaginationItem>
              </Pagination>
          </div>
        </Col>
        
    </Row>
  )
}
export default Transaction
